/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_SaveInputs */

const en_btn_save = /** @type {(inputs: Btn_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Btn_SaveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_save = /** @type {((inputs?: Btn_SaveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_SaveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_save(inputs)
});